import { replace } from 'lodash-es';
import { logError } from './utils/sentry';

const appendScriptToBody = ({ script, name }) => {
  if (document.querySelector('body')) {
    document.querySelector('body').appendChild(script);
  } else {
    const e = new Error(`Failed to inject ${name} script`);
    logError(e);
  }
};

// this injects window.google and not the legacy window.gapi JS api
export const injectGoogleScript = (callback) => {
  if (!window.google) {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = callback;
    script.id = 'google-client-script';
    appendScriptToBody({ script, name: 'google gsi' });
  } else {
    callback();
  }
};

export const injectAppleScript = (locale = 'en_US') => {
  if (!window.apple) {
    const script = window.document.createElement('script');
    const formattedLocale = replace(locale, '-', '_');
    script.src = `https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/${formattedLocale}/appleid.auth.js`;
    script.async = true;
    appendScriptToBody({ script, name: 'apple' });
  }
};

export const injectFacebookScript = ({
  appId,
  version,
  callback,
  locale = 'en_US'
}) => {
  if (!window.FB) {
    window.fbAsyncInit = () => {
      // ref - https://developers.facebook.com/docs/javascript/reference/FB.init/v13.0
      window.FB.init({
        appId,
        xfbml: true,
        version,
        status: true,
        cookie: true
      });
      callback();
    };

    // facebook uses format ll_CC - see https://developers.facebook.com/docs/javascript/internationalization
    const formattedLocale = replace(locale, '-', '_');

    const script = window.document.createElement('script');
    script.src = `https://connect.facebook.net/${formattedLocale}/sdk.js`;
    script.async = true;
    appendScriptToBody({ script, name: 'facebook-jssdk' });
  } else {
    callback();
  }
};

export default { injectGoogleScript, injectAppleScript, injectFacebookScript };
